<template>
    <q-page padding class=" window-width column justify-center items-center">
        <h6 class="text-negative">Страница не найдена</h6>
        <q-btn no-caps flat to="/" label="На главную" color="primary" />
    </q-page>
</template>